import {
  InspectionWizardStepEnum,
  RCIPInspectionRequestVM,
  RCIPInspectionWizardVM,
} from '../../../data/models/coverage-validator-api-models';

// CoverageValidatorAPI's ProductEnum.RCIP.
export const RCIP_PRODUCT_ID = 1;

export const RCIP_STEPS = [
  { step: InspectionWizardStepEnum.BusinessInfo, label: 'Business Info' },
  { step: InspectionWizardStepEnum.Operations, label: 'Operations' },
  { step: InspectionWizardStepEnum.Eligibility, label: 'Eligibility' },
  { step: InspectionWizardStepEnum.Classes, label: 'Classes' },
  { step: InspectionWizardStepEnum.Confirmation, label: 'Confirmation' },
];

export const YES_NO_OPTIONS = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export function yesNoId(value: boolean | null | undefined): string | null {
  return value == null ? null : value ? 'yes' : 'no';
}

export function yesNo(value: boolean | null | undefined): string {
  return value == null ? '' : value ? 'Yes' : 'No';
}

// Policies bound before Shasta asked for owners in the field, employee payroll and class percentages
// have none of the three; Shasta sends them together, so owners alone tells us.
export function hasLegacyQuestions(request: RCIPInspectionRequestVM): boolean {
  return request.numberOfOwnersInField == null;
}

// Legacy policies send the class payroll total, owners included, so it isn't employee payroll.
export function payrollLabel(legacy: boolean): string {
  return legacy ? 'Estimated Annual Payroll' : 'Estimated Annual Employee Payroll';
}

export function percentText(percentage: number | null | undefined): string {
  return percentage == null ? '—' : `${percentage}%`;
}

export function newWizard(productId: number): RCIPInspectionWizardVM {
  return {
    productId,
    currentStep: InspectionWizardStepEnum.BusinessInfo,
    eligibilityReviewed: false,
    classesReviewed: false,
  };
}

// The application with the insured's answers laid over it. Wizard fields share the request's names; null means not answered yet.
export function currentAnswers(
  request: RCIPInspectionRequestVM,
  wizard: RCIPInspectionWizardVM | null,
): RCIPInspectionRequestVM {
  return {
    ...request,
    // The insured writes their own description; Shasta's is only the report's application side.
    descriptionOfOperations: wizard?.descriptionOfOperations ?? null,
    numberOfOwnersInField: wizard?.numberOfOwnersInField ?? request.numberOfOwnersInField,
    numberOfEmployees: wizard?.numberOfEmployees ?? request.numberOfEmployees,
    performNewConstruction: wizard?.performNewConstruction ?? request.performNewConstruction,
    usesDayLabor: wizard?.usesDayLabor ?? request.usesDayLabor,
    grossReceipts: wizard?.grossReceipts ?? request.grossReceipts,
    annualPayroll: wizard?.annualPayroll ?? request.annualPayroll,
    subcontractedCosts: wizard?.subcontractedCosts ?? request.subcontractedCosts,
    typeOfWorkPercentages: wizard?.typeOfWorkPercentages ?? request.typeOfWorkPercentages,
  };
}

// Program statements arrive as rater HTML that opens with an <h4> title; the card shows that title in its header.
export function splitStatement(html: string | null | undefined): { title: string; body: string } {
  const doc = new DOMParser().parseFromString(html ?? '', 'text/html');
  const heading = doc.body.querySelector('h4');
  const title = heading?.textContent?.trim() ?? '';
  heading?.remove();
  return { title, body: doc.body.innerHTML };
}

// TypeOfWork reads "91340 - Carpentry"; the class code is the part before the dash.
export function payrollForClass(
  classCode: string | null | undefined,
  request: RCIPInspectionRequestVM,
): number | null {
  const typeOfWork = request.typeOfWorkPercentages?.find(
    (t) => t.typeOfWork?.split(' - ')[0].trim() === classCode,
  );
  return typeOfWork?.payroll ?? null;
}
